import React from "react";
import { COLORS } from "../../../services/Constant";

const ModuleLight = ({ light, lightData, topLightheads, scale, lightIndex }) => {
  const GAP = 0.3;

  function normalizeTop(top) {
    if (light.angle === "270" && light.left === "0") {
      return +light.top / 1.8;
    }

    if (light.angle === "90") {
      return +light.top + 1.5;
    }

    return +top;
  }

  function normalizeLeft(leftPosition) {
    if (light.angle === "270") {
      return +light.left - 0.85;
    }

    if (light.angle === "180" && parseInt(light.top, 10) > 0) {
      const lightheadPosition = lightData.length - +light.lightheadPosition;

      const oppositeLighthead = topLightheads.find(
        (lighthead) => +lighthead.lightheadPosition === lightheadPosition && light.width === lighthead.width
      );

      return oppositeLighthead ? +oppositeLighthead.left : +leftPosition;
    }

    if (light.angle === "90") {
      return +light.left - +light.height * 2.3;
    }

    return +leftPosition;
  }

  let top = (normalizeTop(+light.top) + GAP / 2) * scale;
  top +=
    ["90", "270"].includes(light.angle) && parseInt(top, 10) > 0
      ? 5
      : ["180"].includes(light.angle) && parseInt(top, 10) > 0
      ? 10
      : 0;
  let left = (normalizeLeft(+light.left) + GAP / 2) * scale;
  const width = (+light.width - GAP) * scale;
  const height = (+light.height + 0.5) * scale;

  let angle = light.angle === "180" && parseInt(light.top, 10) > 0 ? "0" : light.angle;

  if (angle === "270") {
    angle = "90";
    left += 3;
  }

  const noColors = light.moduleOutputs && light.moduleOutputs.length === 0;
  const flexDirection =
    light.moduleOutputs && (light.moduleOutputs.length === 3 || ["90", "270"].includes(light.angle)) ? "row" : "column";
  const isLeft = angle === "90" && left <= 0;
  const isRight = angle === "90" && left > 0;
  const isBottom = angle === "0" && top > 50;
  return (
    <div
      className="lighthead"
      style={{
        position: "absolute",
        left,
        top,
        width,
        height,
        display: "flex",
        flexDirection,
        transform: `rotate(${angle}deg)`,
        backgroundColor: noColors ? "rgb(0, 255, 255)" : "",
      }}
    >
      {light.moduleOutputs.map((output, index) => (
        <div
          key={output.outputId ?? index}
          style={{
            flex: 1,
            width: "100%",
            height: "100%",
            backgroundColor: COLORS[output.outputColor],
          }}
        />
      ))}
      <span
        className={`lighthead-number
        ${isLeft ? "number-left" : isRight ? "number-right" : isBottom ? "number-bottom" : ""}`}
      >
        {lightIndex + 1}
      </span>
    </div>
  );
};

export default ModuleLight;
